import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import {hostUrl, tokenExpiredLoginAgain, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../../constants/global';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import { Link } from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import {shortNameUser, formatPostDate, TopicListData, callPageRenderTracking, truncateContent, LoadingSection } from '../common/Helper';
import BannerImg from '../../assets/images/banner-img.svg';

const ListingSection = React.forwardRef((props,ref) => {

    var currentItems;

    var sectionData =  props.sectionData;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
 
    /******after get the data push in local stage********/
    if(sectionData && data <= 0){
      setData(sectionData);
    }

    /******parent functions******/
    useImperativeHandle(ref, () => ({

        /*****calling from parent******/
        setListingData(data) {
            setData(data);
        }

    }));

    var pages = [];
    
    if(data){
     for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
       pages.push(i);
     }
    }
 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    if(data){
     currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    }
 
    const handleClick = (e) => {
     setcurrentPage(Number(e.target.id));
    }
   
     var renderPageNumbers = pages.map((number)=> {
         if(number < maxPageNumberLimit+1 && number > minPageNumberLimit){
             return <li key={number} className={currentPage ==  number ? "active" : null}><button id={number} type='button' onClick={handleClick}>{number}</button></li>
         }else{
             return null;
         }
     });


     const handlePreviousClick = () => {
        setcurrentPage(currentPage - 1);
  
        if( (currentPage - 1) % pageNumberLimit == 0 ){
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    }
    
  
    const handleNextClick = () => {
        setcurrentPage(currentPage + 1);
  
        if(currentPage+1 > maxPageNumberLimit){
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    }
  
      /*****For pagination******/
      let pageIncrementBtn = null;
      if (pages.length > maxPageNumberLimit) {
        pageIncrementBtn = <li><button type='button' onClick={handleNextClick}>&hellip;</button></li>;
      }
  
      let pageDecrementBtn = null;
      if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li><button type='button' onClick={handlePreviousClick}>&hellip;</button></li>;
      }
     
  return (
        <>
        
        <div className='right-box'>
           
            {/********loading section*******/}
            {props.datatrack === 1 && <LoadingSection/>}

            {props.datatrack === 0 && <>
                {TopicListData(currentItems)}
            </>  }
        

        {(currentItems && data.length>10) && 

            <div className='pageNumbers'>
            <ul>
                    <li><button type='button' onClick={handlePreviousClick} disabled={currentPage == pages[0] ? true : false}>Prev</button></li>
                    
                    {pageDecrementBtn}
                    {renderPageNumbers}
                    {pageIncrementBtn}

                    
                    <li><button type='button' onClick={handleNextClick} disabled={currentPage == pages[pages.length - 1] ? true : false}>Next</button></li>
            </ul>
            </div>
        }
        </div>
        </>
  )
});

export default ListingSection;
